import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import LargeModal from "../../../../components/modals/LargeModal";
import { closePharmacyOrderPartialModal } from "../../../../redux/actions/modals";
import { rejectPharmacyOrder } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";
import OrderItemDrug from "../pharmacy-orders/PharmacyOrderItem/children/OrderItemDrug";
import CharsUtil from "./../../../../utils/characters.js";

const PharmacyOrderPartialComponent = (props) => {
  const dispatch = useDispatch();
  const {
    pharmacy_order_partial_open,
    pharmacy_order_partial_order,
    pharmacy_order_accept_type,
  } = useSelector((state) => state.modals);
  const [hasInsurance, setHasInsurance] = useState(false);
  const [drugItems, setDrugItems] = useState([]);
  const [prices, setPrices] = useState({
    price: "",
    insurance: "",
  });

  const [haveInsurance, setHaveInsurance] = useState(false);
  const [selectedOption, setSelectedOption] = useState("simple");
  const [regularPrice, setRegularPrice] = useState(null);
  const [insurancePrice, setInsurancePrice] = useState(null);
  const [makeClear, setMakeClear] = useState(false);
  const checkInput = (char) => {
    let reg = new RegExp("^[0-9,۰-۹]+$");
    return reg.test(char.trim().replace(",", ""));
  };
  const orderId = (props && props.order && props.order.id) || 0;
  useEffect(() => {
    setRegularPrice(null);
    setInsurancePrice(null);
  }, [orderId]);

  const getDataOfDrugsOtc = (
    itemId,
    description,
    type,
    existence,
    totalItems
  ) => {
    if (drugItems.length === 0) {
      const otcObj = {
        itemId,
        description,
        type: type,
        totalItems: totalItems,
        existItems: existence,
      };
      const updatedArray = [otcObj];
      setDrugItems(updatedArray);
    } else {
      drugItems.map((item) => {
        const drugIndex = drugItems.findIndex((item) => item.itemId === itemId);
        if (drugIndex === -1) {
          const otcObj = {
            itemId,
            description,
            type: type,
            totalItems: totalItems,
            existItems: existence,
          };
          const newArray = [...drugItems];
          const updatedArray = [...newArray, otcObj];
          setDrugItems(updatedArray);
        } else {
          if (type === "OTC" || type === null) {
            if (existence === 1) {
              const newArray = [...drugItems];
              const index = newArray.findIndex(
                (item) => item.itemId === itemId
              );
              if (index > -1) {
                newArray.splice(index, 1);
              }
              setDrugItems(newArray);
            }
          } else {
            const newArray = [...drugItems];
            const index = newArray.findIndex((item) => item.itemId === itemId);
            newArray[index].existItems = existence;
            newArray[index].totalItems = totalItems;
            newArray[index].description = description;
            setDrugItems(newArray);
          }
        }
      });
    }

    // console.log(drugItems)
  };

  const fullPreItemExistence = (itemId) => {
    if (drugItems.length !== 0) {
      const newArray = [...drugItems];
      const index = newArray.findIndex((item) => item.itemId === itemId);
      if (index > -1) {
        newArray.splice(index, 1);
      }
      setDrugItems(newArray);
    }
  };

  const convertNumber = (str) => {
    return str
      .replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d) => {
        return d.charCodeAt(0) - 1632;
      })
      .replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (d) => {
        return d.charCodeAt(0) - 1776;
      });
  };

  const checkAndSendData = () => {
    if (drugItems.length === 0) {
      toaster.error("انتخاب و یا وارد نمودن اقلام ناموجود سفارش الزامی است ");
    } else {
      if (haveInsurance) {
        if (
          insurancePrice === 0 ||
          insurancePrice === null ||
          regularPrice === null ||
          regularPrice === 0 ||
          regularPrice === "" ||
          insurancePrice === ""
        ) {
          toaster.error("هزینه نسخه در این حالت باید وارد شود.");
          return;
        }
      }
      if (selectedOption === "insurance") {
        // console.log(regularPrice)
        if (
          insurancePrice === 0 ||
          insurancePrice === null ||
          regularPrice === null ||
          regularPrice === 0 ||
          regularPrice === "" ||
          insurancePrice === ""
        ) {
          toaster.error("هزینه نسخه در این حالت باید وارد شود.");
          return;
        }
      }
      if (selectedOption === "simple" || selectedOption == "special") {
        if (
          regularPrice === null ||
          regularPrice === 0 ||
          regularPrice === ""
        ) {
          toaster.error("هزینه نسخه در این حالت باید وارد شود.");
          return;
        }
      }
      if (drugItems.length !== 0) {
        drugItems.map((item, index) => {
          if (item.type !== "OTC" || item.type !== null) {
            if (item.description === null || item.description === "") {
              toaster.error("لطفا موارد ناموجود نسخه را وارد نمایید");
              return;
            }
          }
        });
      }
      const rejectData = {
        reason: 'PHARMACY_DRUG_NOT_EXIST_HERE',
        hasPartialOffer: true,
        descriptions: {
          items: [...drugItems],
          useInsurance: haveInsurance || selectedOption === "insurance" ? 1 : 0,
          forceReturn: selectedOption === "special" ? 1 : 0,
          regularPrice:
            regularPrice !== null
              ? regularPrice.toString().replaceAll(",", "")
              : regularPrice,
          insurancePrice:
            (insurancePrice !== null
              ? insurancePrice.toString().replaceAll(",", "")
              : insurancePrice) || 0,
        },
      };
      const data = { ...rejectData, id: props.order.id };
      dispatch(rejectPharmacyOrder(data));
      dispatch(closePharmacyOrderPartialModal());
      setMakeClear(true);
      setDrugItems([]);
      setRegularPrice(null);
      setInsurancePrice(null);
    }
  };

  const renderInputActions = () => {
    if (selectedOption === "insurance") {
      return (
        <Col lg={12} sm={12}>
          <div className="total-price-partial">
            <Form.Group
              as={Row}
              className="form-group-total-price"
              inline
              controlId="formGroupPAY"
            >
              <Form.Label column lg={6} sm={12}>
                مجموع قیمت اقلام موجود بابیمه(تومان)
              </Form.Label>
              <Col className="pr-0" lg={6} sm={12}>
                <Form.Control
                  value={insurancePrice || ""}
                  onChange={(e) => {
                    if (
                      checkInput(e.target.value) ||
                      e.target.value.trim() === ""
                    ) {
                      let price = CharsUtil.FaToEn(e.target.value.toString());
                      price = price
                        .toString()
                        .replace(new RegExp(",", "g"), "")
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                      setInsurancePrice(price);
                      console.log("price", insurancePrice);
                    } else {
                      toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                    }
                  }}
                />
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="form-group-total-price"
              inline
              controlId="formGroupPAY"
            >
              <Form.Label column lg={6} sm={12}>
                مجموع قیمت اقلام موجود بدون بیمه(تومان)
              </Form.Label>
              <Col className="pr-0" lg={6} sm={12}>
                <Form.Control
                  value={regularPrice || ""}
                  onChange={(e) => {
                    if (
                      checkInput(e.target.value) ||
                      e.target.value.trim() === ""
                    ) {
                      let price = CharsUtil.FaToEn(e.target.value.toString());
                      price = price
                        .toString()
                        .replace(new RegExp(",", "g"), "")
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                      setRegularPrice(price);
                      console.log("price", regularPrice);
                    } else {
                      toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                    }
                  }}
                />
              </Col>
            </Form.Group>
          </div>
        </Col>
      );
    } else if (selectedOption === "special") {
      // console.log("here")
      return (
        <>
          <div className="have-special-insurance-holder mb-3">
            <Form.Check
              checked={haveInsurance}
              label="دارو بیمه دارد"
              onChange={(e) => {
                setHaveInsurance(!haveInsurance);
                setInsurancePrice("");
                setRegularPrice("");
                // console.log("haveInsurance chek", !haveInsurance)
              }}
              type="checkbox"
              name="checkHaveInsurance"
              id="haveInsurance"
            />
          </div>
          {haveInsurance ? (
            <Col lg={12} sm={12}>
              <div className="total-price-partial">
                <Form.Group
                  as={Row}
                  className="form-group-total-price"
                  inline
                  controlId="formGroupPAY"
                >
                  <Form.Label column lg={6} sm={12}>
                    مجموع قیمت اقلام موجود بابیمه(تومان)
                  </Form.Label>
                  <Col className="pr-0" lg={6} sm={12}>
                    <Form.Control
                      value={insurancePrice || ""}
                      onChange={(e) => {
                        if (
                          checkInput(e.target.value) ||
                          e.target.value.trim() === ""
                        ) {
                          let price = CharsUtil.FaToEn(
                            e.target.value.toString()
                          );
                          price = price
                            .toString()
                            .replace(new RegExp(",", "g"), "")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                          setInsurancePrice(price);
                        } else {
                          toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="form-group-total-price"
                  inline
                  controlId="formGroupPAY"
                >
                  <Form.Label column lg={6} sm={12}>
                    مجموع قیمت اقلام موجود بدون بیمه(تومان)
                  </Form.Label>
                  <Col className="pr-0" lg={6} sm={12}>
                    <Form.Control
                      value={regularPrice || ""}
                      onChange={(e) => {
                        if (
                          checkInput(e.target.value) ||
                          e.target.value.trim() === ""
                        ) {
                          let price = CharsUtil.FaToEn(
                            e.target.value.toString()
                          );
                          price = price
                            .toString()
                            .replace(new RegExp(",", "g"), "")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                          setRegularPrice(price);
                        } else {
                          toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </div>
            </Col>
          ) : (
            <Col lg={8} sm={12}>
              <div className="total-price-partial">
                <Form.Group
                  as={Row}
                  className="form-group-total-price"
                  inline
                  controlId="formGroupPAY"
                >
                  <Form.Label column lg={6} sm={12}>
                    مجموع قیمت اقلام موجود(تومان)
                  </Form.Label>
                  <Col className="pr-0" lg={6} sm={12}>
                    <Form.Control
                      value={regularPrice || ""}
                      onChange={(e) => {
                        console.log("sdFdsf", e.target.value);
                        if (
                          checkInput(e.target.value) ||
                          e.target.value.trim() === ""
                        ) {
                          let priceM = CharsUtil.FaToEn(
                            e.target.value.toString()
                          );
                          priceM = priceM
                            .toString()
                            .replace(new RegExp(",", "g"), "")
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                          setRegularPrice(priceM);
                        } else {
                          toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                        }
                      }}
                    />
                  </Col>
                </Form.Group>
              </div>
            </Col>
          )}
        </>
      );
    } else {
      return (
        <Col lg={8} sm={12}>
          <div className="total-price-partial">
            <Form.Group
              as={Row}
              className="form-group-total-price"
              inline
              controlId="formGroupPAY"
            >
              <Form.Label column lg={6} sm={12}>
                مجموع قیمت اقلام موجود(تومان)
              </Form.Label>
              <Col className="pr-0" lg={6} sm={12}>
                <Form.Control
                  value={regularPrice || ""}
                  onChange={(e) => {
                    if (
                      checkInput(e.target.value) ||
                      e.target.value.trim() === ""
                    ) {
                      let price = CharsUtil.FaToEn(e.target.value.toString());
                      price = price
                        .toString()
                        .replace(new RegExp(",", "g"), "")
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                      setRegularPrice(price);
                    } else {
                      toaster.warning("لطفا فقط از اعداد استفاده کنید.");
                    }
                  }}
                />
              </Col>
            </Form.Group>
          </div>
        </Col>
      );
    }
  };

  return (
    <>
      <LargeModal
        header="تایید سفارش"
        show={pharmacy_order_partial_open}
        closeFunction={closePharmacyOrderPartialModal}
        className="partial-order-modal"
      >
        <div className="pharmacy-partial-form-holder">
          <div className="insurance-radio-partial">
            <Row className="m-0">
              <Col sm={12} lg={4} className="pr-0 mb-3">
                <div className="radio-item-partial">
                  <Form.Check
                    checked={selectedOption === "simple"}
                    onChange={(e) => {
                      setSelectedOption("simple");
                      setInsurancePrice("");
                      setRegularPrice("");
                    }}
                    inline
                    label="قبول نسخه به صورت عادی"
                    type="radio"
                    name="checkInsurance"
                    id="simple"
                    aria-describedby="passwordHelpBlock"
                  />
                  <Form.Text id="passwordHelpBlock">
                    پیک یک طرفه بدون نیاز به نسخه
                  </Form.Text>
                </div>
              </Col>
              <Col sm={12} lg={4} className="pr-0 mb-3">
                <div className="radio-item-partial">
                  <Form.Check
                    checked={selectedOption === "insurance"}
                    inline
                    label="قبول نسخه تحت پوشش بیمه"
                    onChange={(e) => {
                      setSelectedOption("insurance");
                      setInsurancePrice("");
                      setRegularPrice("");
                    }}
                    type="radio"
                    name="checkInsurance"
                    id="insurance"
                    aria-describedby="passwordHelpBlock"
                  />
                  <Form.Text id="passwordHelpBlock">
                    پیک رفت و برگشت اختیاری جهت دریافت اصل نسخه
                  </Form.Text>
                </div>
              </Col>
              <Col sm={12} lg={4} className="pr-0 mb-3">
                <div className="radio-item-partial">
                  <Form.Check
                    checked={selectedOption === "special"}
                    inline
                    label="قبول نسخه داروی خاص"
                    onChange={(e) => {
                      setSelectedOption("special");
                      setInsurancePrice("");
                      setRegularPrice("");
                    }}
                    type="radio"
                    name="checkSpecial"
                    id="special"
                    aria-describedby="passwordHelpBlock"
                  />
                  <Form.Text id="passwordHelpBlock">
                    پیک رفت و برگشت الزامی جهت دریافت اصل نسخه
                  </Form.Text>
                </div>
              </Col>
            </Row>
          </div>
          <div className="section-title-partial">محتویات نسخه</div>
          <div className="products-partial-holder">
            {props.order !== null &&
              props.order !== undefined &&
              Object.keys(props.order).length !== 0 &&
              props.order.prescriptions.map((prescription, index) => {
                return (
                  <OrderItemDrug
                    makeClear
                    item={prescription}
                    getDataOfDrugsOtc={(
                      itemId,
                      description,
                      type,
                      existence,
                      totalItems
                    ) =>
                      getDataOfDrugsOtc(
                        itemId,
                        description,
                        type,
                        existence,
                        totalItems
                      )
                    }
                    fullPreItemExistence={(itemId) => {
                      fullPreItemExistence(itemId);
                    }}
                  />
                );
              })}
          </div>
          <div className="price-partial-holder">
            <Row className="justify-content-end">{renderInputActions()}</Row>
          </div>
          <div className="actions-btn-partial-order flex-row">
            <button
              className="btn btn-small btn-success btn-accept margin-bottom-5"
              onClick={() => {
                checkAndSendData();
              }}
            >
              تایید سفارش
            </button>
            <button
              className="btn btn-small btn-outline-dark mr-3 btn-accept margin-bottom-5"
              onClick={() => {
                dispatch(closePharmacyOrderPartialModal());
                setMakeClear(true);
                setDrugItems([]);
                setRegularPrice(null);
                setInsurancePrice(null);
              }}
            >
              انصراف
            </button>
          </div>
        </div>
      </LargeModal>
    </>
  );
};
export default PharmacyOrderPartialComponent;
